/**
 * Группы окон TigerTrade, которые принимает `linkGroup`: буквы A–Z и числа
 * 0–11. Протокол TigerTrade (§10 1.45). Трейдер выбирает из них набор для
 * круга в настройках терминала.
 */
export const TERMINAL_LETTER_GROUPS: readonly string[] = Array.from({ length: 26 }, (_, index) =>
  String.fromCharCode("A".charCodeAt(0) + index),
);
export const TERMINAL_NUMBER_GROUPS: readonly string[] = Array.from({ length: 12 }, (_, index) =>
  String(index),
);

const KNOWN_GROUPS: ReadonlySet<string> = new Set([
  ...TERMINAL_LETTER_GROUPS,
  ...TERMINAL_NUMBER_GROUPS,
]);

/** Принимает ли TigerTrade такую группу (регистр значим: буквы только заглавные). */
export function isTerminalGroup(value: string): boolean {
  return KNOWN_GROUPS.has(value);
}
